// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CoverageAnalysisSeverity } from './coverageAnalysisSeverity';
import type { CoverageAnalysisHorizonDays } from './coverageAnalysisHorizonDays';
import type { CoverageAnalysisFilledSegments } from './coverageAnalysisFilledSegments';
import type { CoverageAnalysisRequiredSegments } from './coverageAnalysisRequiredSegments';
import type { CoverageAnalysisFirstSegmentFilled } from './coverageAnalysisFirstSegmentFilled';
import type { CoverageAnalysisSegments } from './coverageAnalysisSegments';
import type { CoverageAnalysisAvailableCount } from './coverageAnalysisAvailableCount';
import type { CoverageAnalysisMinOptions } from './coverageAnalysisMinOptions';

export interface CoverageAnalysis {
  severity: CoverageAnalysisSeverity;
  reason: string;
  horizonDays?: CoverageAnalysisHorizonDays;
  filledSegments?: CoverageAnalysisFilledSegments;
  requiredSegments?: CoverageAnalysisRequiredSegments;
  firstSegmentFilled?: CoverageAnalysisFirstSegmentFilled;
  segments?: CoverageAnalysisSegments;
  availableCount?: CoverageAnalysisAvailableCount;
  minOptions?: CoverageAnalysisMinOptions;
}
